/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Autocomplete } from "@mui/material";
import {
  Grid,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Typography,
  Tooltip,
  Divider,
} from "@mui/material";
import ActivationResourcesTable from "../component/activationResourcesTable";
import classes from "../createPackage/createPackage.module.css";
import TextField from "@mui/material/TextField";
import Input from "../../../component/inputpm";
import Icon from "@mui/material/Icon";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Button from "../../../component/button";
import Delete from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Card } from "@mui/material";
import { DeleteIconNew, EditIconNew } from "../../../component/icons/icons";
import TableContainer from "@mui/material/TableContainer";

const PreQualificationModule = (props) => {
  const { t } = props;

  const updateActivationTableData = (i, e) => {
    props.updateTableFields(i, e, "QUALIFICATION");
  };

  // Add new table row
  const addActivationTableRow = () => {
    props.addNewRow("QUALIFICATION");
  };

  // Remove table row
  const removeActivationTableRow = (i) => {
    props.removeRow("QUALIFICATION", i);
  };

  const [showPasswordActivation, togglePasswordTypeActivation] =
    useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPassword = () => {
    togglePasswordTypeActivation(!showPasswordActivation);
  };

  const getResourceName = (id) => {
    var resourceList = props.preQualResourcesList;
    for (var i = 0; i < resourceList.length; i++) {
      if (resourceList[i].resourceId === id) {
        return resourceList[i].resourceName;
      }
    }
  };
  return (
    <React.Fragment>
      <Grid
        container
        spacing={props.type === "product" ? 1 : 5}
        style={{ marginBottom: "0px" }}
        className={classes.componentDialogPaper}
      >
        <>
          {/* <Paper elevation={3} className={classes.componentDialogPaper}> */}
          {/* <label style={{ fontSize: '16px' }}> */}

          <Grid
            item
            style={{ alignContent: "center" }}
            size={{
              xs: 12,
              md: props.type === "product" ? 12 : 4,
            }}
          >
            <b> {t("CONFIGURE_PREQUALS")} </b>
          </Grid>
          <Grid
            item
            size={{
              xs: 12,
              md: props.type === "product" ? 12 : 8,
            }}
          >
            {/* </label> */}
            <Autocomplete
              options={props.preQualResourcesList}
              onChange={(event, value) =>
                props.selectResource(value, "QUALIFICATION")
              }
              size="small"
              value={props.selectedResource}
              getOptionDisabled={(option) => option.selected}
              getOptionLabel={(option) => option.resourceName}
              style={{ marginTop: "10px" }}
              // disabled={props.mode === 'edit' || props.readonly || props.statusDisplayName === 'Published'}
              disabled={
                props.mode === "edit" ||
                props.readonly ||
                props.status === "P_PUBLISHED"
              }
              classes={{
                option: classes.autoCompleteOption,
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("SELECT_PREQUALS_RESOURCE")}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          {props.selectedResource.resourceName === "Provider REST Callback" &&
            props.tableEditable && (
              <>
                <Grid container spacing={1}>
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <label className="text-body">
                      {t("IMPORT_SWAGGER_DEFINITION")}
                    </label>
                    <Input
                      name={"uploadedFile"}
                      onChange={(event) => props.onuploadedFileChange(event)}
                      inputProps={{ id: "uploadedFile" }}
                      type="file"
                      className="custom-file-input"
                      source={props.uploadedFile}
                      // disabled={props.readonly || props.statusDisplayName === 'Published'}
                      disabled={
                        props.readonly || props.status === "P_PUBLISHED"
                      }
                    />
                    <label
                      htmlFor="uploadedFile"
                      className="input-file-label"
                      style={{ marginTop: "6px" }}
                    >
                      <Icon>attach_file</Icon>
                      <label>
                        {props.uploadedFile ? (
                          props.uploadedFile
                        ) : (
                          <span className="input-file-placeholder">
                            {t("CHOOSE_FILE")}
                          </span>
                        )}
                      </label>
                    </label>
                  </Grid>
                </Grid>
              </>
            )}
          {props.connectionFields && (
            <>
              <Grid container spacing={1}>
                {props.connectionFields &&
                  Object.keys(props.connectionFields).map((key, index) => (
                    <React.Fragment key={index}>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        {index === 0 && (
                          <label className="text-body">
                            {t("CONNECTION_PARAMETERS")}
                          </label>
                        )}
                        {key.includes("Password") ? (
                          <FormControl
                            variant="outlined"
                            size={"small"}
                            style={{ marginTop: "6px" }}
                          >
                            <InputLabel id="passwordLabel">
                              {key}
                            </InputLabel>
                            <OutlinedInput
                              id="outlined-adornment-password"
                              label={key}
                              labelId="passwordLabel"
                              type={
                                showPasswordActivation ? "text" : "password"
                              }
                              name={key}
                              value={props.connectionFields[key]}
                              onChange={(event) =>
                                props.updateConnectionFields(
                                  event,
                                  "QUALIFICATION",
                                )
                              }
                              // disabled={props.readonly || props.statusDisplayName === 'Published'}
                              disabled={
                                props.readonly || props.status === "P_PUBLISHED"
                              }
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() => handleClickShowPassword()}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                  >
                                    {showPasswordActivation ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                        ) : (
                          <Input
                            name={key}
                            variant={"outlined"}
                            onChange={(event) =>
                              props.updateConnectionFields(
                                event,
                                "QUALIFICATION",
                              )
                            }
                            placeholder={key}
                            size={"small"}
                            value={props.connectionFields[key]}
                            style={{ marginTop: "6px" }}
                            // disabled={props.readonly || props.statusDisplayName === 'Published'}
                            disabled={
                              props.readonly || props.status === "P_PUBLISHED"
                            }
                          />
                        )}
                      </Grid>
                    </React.Fragment>
                  ))}
              </Grid>
            </>
          )}
          {/* {props.tableFields.length > 0 && */}
          {props.selectedResource.resourceId && (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <ActivationResourcesTable
                activationParams={props.tableFields}
                activationParamEditable={props.tableEditable}
                addActivationParam={addActivationTableRow}
                changeActivationParam={updateActivationTableData}
                removeActivationParam={removeActivationTableRow}
                type={"Activation"}
                readonly={props.readonly}
                statusDisplayName={props.statusDisplayName}
                selectedResource={props.selectedResource}
                mode={props.mode}
                cancelEdit={props.cancelEdit}
                submitData={props.submitData}
              />
            </Grid>
          )}
          {/* {props.selectedResource.resourceId &&
                        <div align="right">
                            {props.readonly ? '' :
                                <>
                                    {props.mode === 'edit' ?
                                        <>
                                            <Button onClick={props.cancelEdit} style={{ marginRight: '15px' }}>{t('CANCEL')}</Button>
                                            <Button onClick={props.submitData}>{t('UPDATE')}</Button>
                                        </>
                                        :
                                        ((props.tableFields.length > 0) &&
                                        <Button onClick={props.submitData}>{t('ADD')}</Button>)
                                    }
                                </>
                            }
                        </div>
                    } */}
          {/* </Paper> */}
        </>
        {props.preQuals.length > 0 && (
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            {/* <Paper elevation={3} className={classes.componentDialogPaper}> */}
            <div style={{ marginBottom: ".5rem" }}>
              <b>{t("ADDED_PREQUALS")}</b>
            </div>
            <Card
              variant="outlined"
              style={{ borderRadius: "8px", marginBottom: "40px" }}
            >
              <TableContainer>
                <Table className="newGlobalTable roundCorners">
                  {props.preQuals.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <TableCell>{t("RESOURCE_NAME")}</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {props.preQuals.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {getResourceName(item.resourceId)}
                        </TableCell>
                        <TableCell align="right">
                          {/* {props.readonly || props.statusDisplayName === 'Published' ? '' : */}
                          {props.readonly || props.status === "P_PUBLISHED" ? (
                            ""
                          ) : (
                            <>
                              <Tooltip
                                title={t("DELETE")}
                                style={{ marginRight: "5px" }}
                              >
                                <IconButton
                                  className="buttonSecondary"
                                  onClick={() => {
                                    props.deletePreQual(index);
                                  }}
                                >
                                  <DeleteIconNew />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t("EDIT")}>
                                <IconButton
                                  className="buttonSecondary"
                                  onClick={() => {
                                    props.editPreQual(item, index);
                                  }}
                                >
                                  <EditIconNew />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                    {props.components &&
                      props.components.length > 0 &&
                      props.components.map(
                        (comp, index) =>
                          comp.preQuals &&
                          comp.preQuals.length > 0 && (
                            <>
                              <TableRow>
                                <TableCell>
                                  <b>{comp.name}</b>
                                </TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                              {comp.preQuals.map((item, pi) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {getResourceName(item.resourceId)}
                                  </TableCell>
                                  <TableCell align="right"></TableCell>
                                </TableRow>
                              ))}
                            </>
                          ),
                      )}
                    {props.preQuals.length === 0 && (
                      <TableRow>
                        <TableCell>{t("NO_PRE_QUALS_ADDED")}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
            {/* </Paper> */}
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //setErrorMessage: (errMsg, msgType) => dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(PreQualificationModule));
